import React from "react";
import { Loader2 } from "lucide-react";

interface LoadingStateProps {
  message?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = "Loading...",
}) => {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-surface bg-opacity-75">
      <div className="flex items-center">
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
        <span className="text-text-muted">{message}</span>
      </div>
    </div>
  );
};
